import { useReactiveVar } from "@apollo/client";
import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearFeatureLanguage, getActiveFeature } from "./featureLanguageSession";
import i18n from "./i18n";
import { marketLanguageMap } from "./marketLanguageMap";
import { __currentUser__ } from "../graphql/policies";
import { MarketType } from "../types/types";

export const useInitLanguage = () => {
  const location = useLocation();

  const currentUser = useReactiveVar(__currentUser__);
  const isAuthenticated = useIsAuthenticated();
  const isMarketType = (value: string): value is MarketType => {
    return ["JP", "KR", "HK", "TW"].includes(value);
  };
  const defaultMarket = currentUser?.afUserMarkets?.[0]?.market;

  // auth default setting with market
  useEffect(() => {
    if (!isAuthenticated || !defaultMarket) return;
    if (!defaultMarket || !isMarketType(defaultMarket)) return;

    const lang = marketLanguageMap[defaultMarket] ?? "en";

    if (i18n.resolvedLanguage === lang) return;
    
    i18n.changeLanguage(lang);
  }, [isAuthenticated, defaultMarket]);

  // when navigating away from the active feature,
  // restore language back to the account default
  useEffect(() => {
    const activeFeature = getActiveFeature();
    if (!activeFeature) return;

    if (!location.pathname.includes(activeFeature)) {
      clearFeatureLanguage();
    }
  }, [location.pathname]);
};
